export const OPENING_SURVEY = 'OPENING_SURVEY';
